import { createInitialStates, createResourceNames, createSequenceTypes, getErrorData } from '../helpers'
import { INITIAL_STATE_REDUCERS } from '../constants'

const RESOURCES = [
  'ordersByIdGet',
  'ordersByIdEventsGet',
  'ordersByIdRefund',
  'ordersCustomSearchGet',
  'ordersGet',
  'ordersSearchByCreatedAtGet',
  'ordersSearchByPaymentMethodGet',
  'ordersSearchByStatusGet',
  'ordersSearchGet'
]
const R = createResourceNames(RESOURCES)
const TYPES = createSequenceTypes([
  'ORDERS_BY_ID_GET',
  'ORDERS_BY_ID_EVENTS_GET',
  'ORDERS_BY_ID_REFUND',
  'ORDERS_CUSTOM_SEARCH_GET',
  'ORDERS_GET',
  'ORDERS_SEARCH_BY_CREATED_AT_GET',
  'ORDERS_SEARCH_BY_PAYMENT_METHOD_GET',
  'ORDERS_SEARCH_BY_STATUS_GET',
  'ORDERS_SEARCH_GET'
])
export const INITIAL_STATE = {
  ...createInitialStates(RESOURCES, INITIAL_STATE_REDUCERS)
}

const reducers = {
  // ORDERS BY ID GET ··································································································
  [TYPES.ORDERS_BY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.ordersByIdGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ORDERS_BY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.ordersByIdGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ORDERS_BY_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.ordersByIdGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ORDERS_BY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.ordersByIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ORDERS BY ID EVENTS GET ························································································
  [TYPES.ORDERS_BY_ID_EVENTS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.ordersByIdEventsGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ORDERS_BY_ID_EVENTS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.ordersByIdEventsGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ORDERS_BY_ID_EVENTS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.ordersByIdEventsGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ORDERS_BY_ID_EVENTS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.ordersByIdEventsGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ORDERS BY ID REFUND ·······························································································
  [TYPES.ORDERS_BY_ID_REFUND_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.ordersByIdRefund]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ORDERS_BY_ID_REFUND_SUCCESSFUL]: (state: any, payload: any) => {
    const data = { responseStatus: payload.status, ...payload.data }
    return {
      ...state,
      [R.ordersByIdRefund]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ORDERS_BY_ID_REFUND_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.ordersByIdRefund]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ORDERS_BY_ID_REFUND_RESET]: (state: any) => {
    const RESOURCE_NAME = R.ordersByIdRefund
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ORDERS CUSTOM SEARCH GET ··························································································
  [TYPES.ORDERS_CUSTOM_SEARCH_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.ordersCustomSearchGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ORDERS_CUSTOM_SEARCH_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return { ...state, [R.ordersCustomSearchGet]: { data, error: {}, isLoading: false } }
  },
  [TYPES.ORDERS_CUSTOM_SEARCH_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return { ...state, [R.ordersCustomSearchGet]: { data: [], error, isLoading: false } }
  },
  [TYPES.ORDERS_CUSTOM_SEARCH_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.ordersCustomSearchGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ORDERS GET ········································································································
  [TYPES.ORDERS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.ordersGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ORDERS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return { ...state, [R.ordersGet]: { data, error: {}, isLoading: false } }
  },
  [TYPES.ORDERS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return { ...state, [R.ordersGet]: { data: [], error, isLoading: false } }
  },
  [TYPES.ORDERS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.ordersGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ORDERS SEARCH BY CREATED AT GET ···················································································
  [TYPES.ORDERS_SEARCH_BY_CREATED_AT_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.ordersSearchByCreatedAtGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ORDERS_SEARCH_BY_CREATED_AT_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.ordersSearchByCreatedAtGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ORDERS_SEARCH_BY_CREATED_AT_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.ordersSearchByCreatedAtGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ORDERS_SEARCH_BY_CREATED_AT_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.ordersSearchByCreatedAtGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ORDERS SEARCH BY METHOD TYPE GET ··················································································
  [TYPES.ORDERS_SEARCH_BY_PAYMENT_METHOD_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.ordersSearchByPaymentMethodGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ORDERS_SEARCH_BY_PAYMENT_METHOD_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.ordersSearchByPaymentMethodGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ORDERS_SEARCH_BY_PAYMENT_METHOD_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.ordersSearchByPaymentMethodGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ORDERS_SEARCH_BY_PAYMENT_METHOD_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.ordersSearchByPaymentMethodGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ORDERS SEARCH BY STATUS GET ·······················································································
  [TYPES.ORDERS_SEARCH_BY_STATUS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.ordersSearchByStatusGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ORDERS_SEARCH_BY_STATUS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.ordersSearchByStatusGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ORDERS_SEARCH_BY_STATUS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.ordersSearchByStatusGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ORDERS_SEARCH_BY_STATUS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.ordersSearchByStatusGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ORDERS SEARCH GET ·································································································
  [TYPES.ORDERS_SEARCH_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.ordersSearchGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ORDERS_SEARCH_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.ordersSearchGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ORDERS_SEARCH_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.ordersSearchGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ORDERS_SEARCH_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.ordersSearchGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  }
}

export default reducers
